import { FREE_SHIPPING_INDICATOR } from 'shared/experiments/consts/names'
import { EXPERIMENT_VARIATION } from 'shared/experiments/consts/variants'
import type { Experiment } from 'types/shopConfig'

export const freeShippingIndicatorExperiment: Experiment = {
  name: FREE_SHIPPING_INDICATOR,
  isEnabled: true,
  variables: { f: 1 },
  variant: EXPERIMENT_VARIATION.V2,
}
